import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SearchCatalogItemsSchema } from 'features/SearchCatalogItems';

const initialState: SearchCatalogItemsSchema = {
    isActive: false,
    globalCatItemSearchValue: '',
    localCatItemSearchValue: '',
};

export const SearchCatalogItemsSlice = createSlice({
    name: 'SearchCatalogItems',
    initialState,
    reducers: {
        setActive: (state, action: PayloadAction<boolean>) => {
            state.isActive = action.payload;
        },
        setGlobalCatItemSearchValue: (state, action: PayloadAction<string>) => {
            state.globalCatItemSearchValue = action.payload;
        },
        setLocalCatItemSearchValue: (state, action: PayloadAction<string>) => {
            state.localCatItemSearchValue = action.payload;
        },
        resetSearch: () => initialState,
    },
});

export const { actions: searchCatalogItemsActions } = SearchCatalogItemsSlice;
export const { reducer: searchCatalogItemsReducer } = SearchCatalogItemsSlice;
